import { action, observable } from "mobx";
import mmsApi from 'src/apis/mmsApi';
import { Stores } from 'src/stores';
import {BaseStore} from "mam-core-react";
import _ from 'lodash';
import iSearchTypes from 'src/types/iSearchTypes';

export default class IOutputExcelStore extends BaseStore<Stores>{
    // 控制下载弹窗
    @observable
    public showOutputExcelModal:boolean = false

    @observable
    public req: iSearchTypes.IFullSearchDataReq

    @observable
    public isSelectItem:any

    public constructor(stores: Stores){
        super(stores);
    }

    @action
    public setShowOutputExcelModal(show:boolean){
        this.showOutputExcelModal = show
    }

    @action
    public setReq(req: iSearchTypes.IFullSearchDataReq){
        this.req =req
    }

    @action
    public outputExcel(isSelectItem:any[]){
        this.isSelectItem = isSelectItem;
        this.setShowOutputExcelModal(true)
        if(isSelectItem.length <= 0){
            const size: number = this.stores.configStore.config.searchBase.exportToExcelMaxLimit || 1000;
            this.getQueryRequest(size)
        }else{
            //清空列表选中
            this.stores.iSearchStore.selectAllStore.switchAllSelected(false);
            this.stores.iSearchStore.selectAllStore.switchListItemSelected(undefined, false);
        }
    }

    @action 
    public outputExcelPart(isSelectItem:any[]){
        if(isSelectItem.length > 0){
            const contentIds: string[] = isSelectItem.map(item => {
                return item.contentId_
            })
            mmsApi.OutputExcelModal.exportCsvForPart(contentIds)
        }
    }

    @action 
    public getQueryRequest(size:number){
        let param = this.stores.iSearchStore.getFullSearchParam(1);
        param.pageSize = size;
        this.setReq(param)
    }

    @action
    public keywordCheck(keyword:string[]){
        return true
    }
}